"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const iconoir_react_1 = require("iconoir-react");
const Pagination = (props) => {
    const { count, page, rowsPerPage, rowsPerPageOptions, onPageChange, onRowsPerPageChange, ...rest } = props;
    return (react_1.default.createElement(material_1.TablePagination, { component: "div", count: count, page: page, labelRowsPerPage: "", rowsPerPage: rowsPerPage, rowsPerPageOptions: rowsPerPageOptions, onPageChange: onPageChange, onRowsPerPageChange: onRowsPerPageChange, SelectProps: {
            IconComponent: iconoir_react_1.NavArrowDown,
            MenuProps: {
                PaperProps: {
                    sx: { backgroundColor: "transparent" },
                },
            },
        }, sx: {
            "&.MuiSelect-icon": { top: "10px", right: "4px", fontSize: "0.9rem" },
            p: 0,
            borderRadius: "8px",
        }, ...rest }));
};
exports.default = Pagination;
